import { render, staticRenderFns } from "./TooltipWithIcon.vue?vue&type=template&id=4387da62"
import script from "./TooltipWithIcon.vue?vue&type=script&lang=js"
export * from "./TooltipWithIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports